/* Helper function to construct a Request object to verify a Google or Apple ID Token */
const constructVerificationRequest = (idToken, requestUri, requestParams) => {
  const
    headers = new Headers({
      'content-type': 'application/json',
      'Accept': 'application/json',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
    }),
    requestBody = {
      id_token: idToken,
      ...requestParams
    },
    payload = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(requestBody)
    };
  return new Request(requestUri, payload);
};


/* Helper function to perform a Google or Apple login and redirect */
const oauthButtonHandler = async params => {
  const  errorField = document.querySelector('.get-started-error');
  // If there are any selected newsletters on the page, send their ids to the server as well
  const selectedNewsletterIds = [...document.querySelectorAll('.newsletter-subscribed')].map(elt => elt.dataset.newsletterId);
  try {
    const response = await fetch(
      constructVerificationRequest(
        params.idToken,
        params.verificationUri,
        {...params.verificationExtras, newsletter_ids: selectedNewsletterIds}
      )
    );
    const responseBody = await response.json();
    if (response.ok) {
      if (params.onSuccess) {
        params.onSuccess(responseBody);
      }
      window.location.href = responseBody.redirect_url || responseBody.location;
    }
    else if (response.status == 422) {
      errorField.innerHTML = responseBody.message;
      errorField.classList.add('has-error');
    }
    else {
      throw `Could not log in with ${params.verificationExtras.provider}`;
    }
  }
  catch(e) {
    const errorField = document.querySelector('.get-started-error');
    errorField.innerHTML = e;
    errorField.classList.add('has-error');
    throw e;
  }
};

export { oauthButtonHandler }
